import { GET_DATA_INFOMATION, EDIT_DATA_INFOMATION } from "./type";

const initialState = {
  dataInfoRevenvue: [],
  dataEditInfo: [],
};

export const reducerInfoRevenue = (state = initialState, action) => {
  switch (action.type) {
    case GET_DATA_INFOMATION:
      return {
        ...state,
        dataInfoRevenvue: action.payload,
      };
    case EDIT_DATA_INFOMATION:
      return {
        ...state,
        dataEditInfo: action.payload,
      };
    default:
      return state;
  }
};
